export default {"src":"/_next/static/media/home-deals-bg.b1800754.svg","height":428,"width":771,"blurWidth":0,"blurHeight":0};